import React from "react";
import Card from "../card/Card";
import ErrorMessage from "../error-message/ErrorMessage";
import { getAttachment, getDocuments, postDocument } from "../../services/ClaimDetailsPage.Service";
import Loader from "../loader/Loader";
import "../../styles/ClaimDocuments.scss";

/*var allowedExtensions = /(\.mov|\.html|\.xml|\.rar|\.png|\.txt|\.ico|\.csv|\.xlsx|\.pptx|\.rtf|\.bmp|\.tiff|\.tif|\.gif|\.jpeg|\.jpg|\.zip|\.xls|\.ppt|\.docx|\.doc|\.pdf)$/i;*/
var allowedExtensions = /(\.mov|\.png|\.txt|\.csv|\.xlsx|\.gif|\.jpeg|\.jpg|\.xls|\.docx|\.doc|\.pdf)$/i;
const ClaimDocument = ({ claimDocuments, claimNumber, claimId }) => {
    const [fileTypeError, setFileTypeError] = React.useState(null);
    const [documents, setDocuments] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);
    const [fileSizeError, setFileSizeError] = React.useState(null);
    const [expireMessage, setExpireMessage] = React.useState(null);
    const tpaData = JSON.parse(localStorage.getItem('tpa_data'));

    React.useEffect(() => {
        if (claimDocuments) {
            formatDocumnetsData(claimDocuments);
            return;
        }
    }, [claimDocuments])

    const onChangeFileUpload = (event, direction, identifier, notes, documentType) => {
        event.preventDefault();
        event.stopPropagation();
        document.getElementById(identifier).classList.add('drop-zone-container-highlight');
        setIsLoading(true);
        document.body.style.overflow = 'hidden';
        var files = event.target.files[0];
        if (!files) {
            setIsLoading(false);
            document.body.style.overflow = 'auto';
            return;
        }
        if (!allowedExtensions.exec(files.name)) {
            setFileTypeError(null);
            setFileTypeError("File Type is not supported");
            setIsLoading(false);
            document.body.style.overflow = 'auto';
            return;
        }
        setFileTypeError(null);
        const reader = new FileReader();
        const maxFileSize = 6 * 1024 * 1024;
        if (files.size > maxFileSize) {
            setFileSizeError("The maximum size of file is 5 MB.");
            setIsLoading(false);
            document.body.style.overflow = 'auto';
            return;
        }
        setFileSizeError(null);
        reader.readAsDataURL(files);
        reader.onload = async () => {
            const fileContent = reader.result.split(',')[1];
            var fileData;
            if (tpaData.admin_Type === 'SEA') {
                fileData = {
                    "fileName": files.name,
                    "fileContent": fileContent,
                    "notes": notes,
                    "additionalInformation": "",
                    "documentType": documentType
                }
            } else {
                fileData = {
                    "fileName": files.name,
                    "fileContent": fileContent,
                    "notes": notes,
                    "additionalInformation": "",
                    "documentType": documentType
                }
            }
            var claimIdentifier = tpaData?.admin_Type === 'SEA' ? claimId : identifier;
            const res = await postDocument(claimNumber, direction, claimIdentifier, fileData);
            if (res.data) {
                if (tpaData?.admin_Type.toLowerCase() === 'sea') {
                    const selectedIndex = documents?.findIndex(x => x.attachmentData?.identifier === identifier);
                    documents[selectedIndex].attachmentData.latestAttachment = {
                        'fileName': files.name,
                        'fileSize': files.size,
                        'downloadUrl': URL.createObjectURL(files),
                        'createdDate': new Date(),
                    }
                    setDocuments(documents);
                } else {
                    await getUpdatedDocuments();
                }
                setIsLoading(false);
                document.body.style.overflow = 'auto';
                document.getElementById(identifier)?.classList.remove('drop-zone-container-highlight');
                return;
            }
            setIsLoading(false);
            document.body.style.overflow = 'auto';
            return;
        }
    }

    const fileUpload = (event, direction, identifier, notes, documentType) => {
        event.preventDefault();
        event.stopPropagation();
        setIsLoading(true);
        document.body.style.overflow = 'hidden';
        if (document.getElementById('dropZone') != null) {
            document.getElementById('dropZone').classList.remove('drop-zone-container-highlight');
        }

        var dt = event.dataTransfer;
        var files = dt.files[0];
        if (!allowedExtensions.exec(files.name)) {
            setFileTypeError("File Type is not supported.");
            setIsLoading(false);
            document.body.style.overflow = 'auto';
            return;
        }
        setFileTypeError(null);
        const maxFileSize = 6 * 1024 * 1024;
        if (files.size > maxFileSize) {
            setFileSizeError("The maximum size of file is 5 MB.");
            setIsLoading(false);
            document.body.style.overflow = 'auto';
            return;
        }
        setFileSizeError(null);
        var reader = new FileReader();
        reader.readAsDataURL(files);
        reader.onload = async () => {
            const fileContent = reader.result.split(',')[1];
            var fileData;
            if (tpaData.admin_Type === 'SEA') {
                fileData = {
                    "fileName": files.name,
                    "fileContent": fileContent,
                    "notes": notes,
                    "additionalInformation": "",
                    "documentType": documentType
                }
            } else {
                fileData = {
                    "fileName": files.name,
                    "fileContent": fileContent,
                    "notes": notes,
                    "additionalInformation": "",
                    "documentType": documentType
                }
            }
            var claimIdentifier = tpaData?.admin_Type === 'SEA' ? claimId : identifier;
            const res = await postDocument(claimNumber, direction, claimIdentifier, fileData);
            if (res.data) {
                if (tpaData?.admin_Type.toLowerCase() === 'sea') {
                    const selectedIndex = documents?.findIndex(x => x.attachmentData?.identifier === identifier);
                    documents[selectedIndex].attachmentData.latestAttachment = {
                        'fileName': files.name,
                        'fileSize': files.size,
                        'downloadUrl': URL.createObjectURL(files),
                        'createdDate': new Date(),
                    }
                    setDocuments(documents);
                } else {
                    await getUpdatedDocuments();
                }
                setIsLoading(false);
                document.body.style.overflow = 'auto';
                return;
            }
            setIsLoading(false);
            document.body.style.overflow = 'auto';
        }
    }

    const getAttachmentData = async (attachmentId, direction, fileName, fileURL, expiresTime) => {
        setIsLoading(true);
        if (tpaData?.admin_Type.toLowerCase() === 'sea') {
            const expireTime = new Date(expiresTime).getTime();
            const currentTime = new Date().getTime();
            if (currentTime > expireTime) {
                setExpireMessage('Document link has expired.  Please refresh your browser and try again.')
                setIsLoading(false);
                return;
            }
            setExpireMessage(null);
            window.open(fileURL);
            setIsLoading(false);
            return;
        }
        document.body.style.overflow = 'hidden';
        const reqObj = {
            "direction": direction,
            "attachmentId": attachmentId
        };
        const res = await getAttachment(reqObj);
        if (res.data) {
            var reader = new FileReader();
            reader.readAsDataURL(res.data);
            reader.onload = () => {
                const downloadLink = document.createElement("a");
                downloadLink.href = reader.result;
                downloadLink.download = fileName;
                downloadLink.click();
            }
            setIsLoading(false);
            document.body.style.overflow = 'auto';
            return;
        }
        setIsLoading(false);
        document.body.style.overflow = 'auto';
        return;
    }

    const formatDocumnetsData = (documentData) => {
        const data = documentData?.map((item) => {
            if (item?.attachmentData?.attachments && item?.attachmentData?.attachments.length > 0) {
                item.attachmentData.latestAttachment = item.attachmentData.attachments.reduce((a, b) => a.createdDate > b.createdDate ? a : b);
                return { ...item }
            }
            item.attachmentData.latestAttachment = null;
            return { ...item };
        });
        setDocuments(data);
        return;
    }

    const getUpdatedDocuments = async () => {
        const claimObj = {
            "claim_number": claimNumber,
            "claim_id": claimId
        };
        const res = await getDocuments(claimObj);
        if (res.data) {
            setIsLoading(false);
            const header = await JSON.parse(localStorage.getItem("tpa_data"));
            var attachmentsData = [];
            if (tpaData?.admin_Type.toLowerCase() === 'sea') {
                header?.required_docs?.forEach((item, i) => {
                    const selectedData = res?.data?.find(x => x.description === item.documentName);
                    if (selectedData) {
                        const selectedAttachment = { ...item, attachmentData: selectedData };
                        attachmentsData.push(selectedAttachment);
                    } else {
                        const selectedAttachment = { ...item, attachmentData: { 'identifier': `sea-${i}` } }
                        attachmentsData.push(selectedAttachment);
                    }
                });
            } else {
                header?.required_docs?.forEach((item) => {
                    const selectedData = res?.data?.find(x => x.description === item.documentName);
                    if (selectedData) {
                        const selectedAttachment = { ...item, attachmentData: selectedData };
                        attachmentsData.push(selectedAttachment);
                    }
                });
            }
            formatDocumnetsData(attachmentsData);
            return;
        }
        setIsLoading(false);
        return;
    }
    const getFormattedDate = (date) => {
        const maxDate = new Date(date);
        var day = maxDate.getDate();
        var month = maxDate.getMonth() + 1;
        var year = maxDate.getFullYear();
        if (day < 10) {
            day = '0' + day;
        }
        if (month < 10) {
            month = '0' + month;
        }
        var formattedMaxDate = month + '/' + day + '/' + year;
        return formattedMaxDate;
    }

    const routeToLandingPage = () => {
        window.location = window.location.origin + '/' + window.location.pathname.split("/")[1];
    }

    return (
        <React.Fragment>
            {isLoading ? <Loader /> : ""}
            <div className="card-container">
                <Card cardTitle={`Claim Documents: ${(documents?.length === 0 && tpaData?.admin_Type === 'SEA') ? tpaData?.required_docs?.length ?? 0 : documents?.length ?? 0}`} cardIcon="fas fa-file-contract">
                    <div className="ml-30">
                        <div className="document-helper-text">
                        Attach your documents to the corresponding sections below.
                        </div>
                        <div className="tooltip-container">
                            <div className="tooltip">Files we accept
                                <div className="tooltiptext">
                                    <h6 className="tooltip-header-text">Acceptable files include:</h6>
                                    <div className="tooltip-content-text">
                                    PDF documents are preferred; however we can also accept word documents, spreadsheets and most image files.
                                    </div>
                                </div>
                            </div>
                            <span className="document-helper-text ml-5">should be less than 5MB in file size.</span>
                        </div>
                    </div>
                    <div className="document-helper-text required-text mt-20">Required documents</div>
                    {/*{tpaData?.admin_Type === 'SEA' && <div className="mt-20">*/}
                    {/*    <label htmlFor="file">*/}
                    {/*        <div*/}
                    {/*            className="drop-zone-container"*/}
                    {/*            data-testid="sea-dropzone-test"*/}
                    {/*            id="sea-dropzone"*/}
                    {/*            onFocus={() => {*/}
                    {/*                document.getElementById('sea-dropzone').classList.add('drop-zone-container-highlight');*/}
                    {/*            }}*/}
                    {/*            onBlur={() => {*/}
                    {/*                document.getElementById('sea-dropzone').classList.remove('drop-zone-container-highlight');*/}
                    {/*            }}*/}
                    {/*        >*/}
                    {/*            <i className="fa fa-plus" />*/}
                    {/*            <div className="document-container">*/}
                    {/*                <h1 className="category-title">Other</h1>*/}
                    {/*                <p className="upload-suggetion"><span className="click-text">Click here;</span> or drag a document to upload.</p>*/}
                    {/*                <input*/}
                    {/*                    type="file"*/}
                    {/*                    name="sea-dropzone"*/}
                    {/*                    data-testid="sea-dropzone-test"*/}
                    {/*                    className="file-upload"*/}
                    {/*                    title=""*/}
                    {/*                    onChange={(e) => { onChangeFileUpload(e, '', 'sea-dropzone', '') }}*/}
                    {/*                    onDragEnter={(e) => {*/}
                    {/*                        e.preventDefault();*/}
                    {/*                        e.stopPropagation();*/}
                    {/*                        document.getElementById('sea-dropzone').classList.add('drop-zone-container-highlight');*/}
                    {/*                    }}*/}
                    {/*                    onDragOver={(e) => {*/}
                    {/*                        e.preventDefault();*/}
                    {/*                        e.stopPropagation();*/}
                    {/*                    }}*/}
                    {/*                    onDragLeave={(e) => {*/}
                    {/*                        e.preventDefault(); e.stopPropagation();*/}
                    {/*                        document.getElementById('sea-dropzone').classList.remove('drop-zone-container-highlight');*/}
                    {/*                    }}*/}
                    {/*                    onDrop={(e) => { fileUpload(e, '', 'sea-dropzone', '') }} />*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    </label>*/}
                    {/*</div>}*/}
                    {/*{tpaData?.admin_Type === 'SEA' && documents.length > 0 && documents.map((item, i) => {*/}
                    {/*    if (item.attachmentData.latestAttachment) {*/}
                    {/*        return (*/}
                    {/*            <div className="mt-20" key={i}>*/}
                    {/*                <div*/}
                    {/*                    className="drop-zone-container"*/}
                    {/*                    data-testid={`${item.attachmentData.identifier}-file-replace`}*/}
                    {/*                    id={item.attachmentData.identifier}*/}
                    {/*                    onFocus={() => {*/}
                    {/*                        document.getElementById(item.attachmentData.identifier).classList.add('drop-zone-container-highlight');*/}
                    {/*                    }}*/}
                    {/*                    onBlur={() => {*/}
                    {/*                        document.getElementById(item.attachmentData.identifier).classList.remove('drop-zone-container-highlight');*/}
                    {/*                    }}*/}
                    {/*                >*/}
                    {/*                    <i className="fa fa-check" style={{ color: 'green' }} />*/}
                    {/*                    <div className="document-container">*/}
                    {/*                        <div className="category-title">{item.attachmentData.description}</div>*/}
                    {/*                        <div className="d-flex">*/}
                    {/*                            <p className="upload-suggetion">Added {getFormattedDate(item.attachmentData.latestAttachment.createdDate)}</p>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*        )*/}
                    {/*    }*/}
                    {/*})}*/}
                    {documents.length === 0 && tpaData.admin_Type === 'SEA' &&
                        tpaData.required_docs?.map((item, i) => {
                            return (
                                <div className="mt-20" key={i}>
                                    <div
                                        className="drop-zone-container"
                                        data-testid={`${i}-file-replace`}
                                        id={i}
                                        onFocus={() => {
                                            document.getElementById(i).classList.add('drop-zone-container-highlight');
                                        }}
                                        onBlur={() => {
                                            document.getElementById(i).classList.remove('drop-zone-container-highlight');
                                        }}
                                    >
                                        <i className="fa fa-plus" />
                                        <div className="document-container">
                                            <h1 className="category-title">{item.displayName}</h1>
                                            <p className="upload-suggetion"><span className="click-text">Click here;</span> or drag a document to upload.</p>
                                            <input
                                                data-testid={i}
                                                type="file"
                                                name={item.documentName}
                                                className="file-upload"
                                                title=""
                                                onChange={(e) => { onChangeFileUpload(e, '', i, '', item.documentName) }}
                                                onDragEnter={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    document.getElementById(i).classList.add('drop-zone-container-highlight');
                                                }}
                                                onDragOver={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                }}
                                                onDragLeave={(e) => {
                                                    e.preventDefault(); e.stopPropagation();
                                                    document.getElementById(i).classList.remove('drop-zone-container-highlight');
                                                }}
                                                onDrop={(e) => { fileUpload(e, '', i, '', item.documentName) }} />
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                    {documents?.length > 0 && documents?.map((item, i) => {
                        if (item.attachmentData.latestAttachment) {
                            return (
                                <div className="mt-20" key={i}>
                                    {item?.allowUpload ?
                                        <div
                                            className="drop-zone-container"
                                            data-testid={`${item.attachmentData.identifier}-file-replace`}
                                            id={item.attachmentData.identifier}
                                            onFocus={() => {
                                                document.getElementById(item.attachmentData.identifier).classList.add('drop-zone-container-highlight');
                                            }}
                                            onBlur={() => {
                                                document.getElementById(item.attachmentData.identifier).classList.remove('drop-zone-container-highlight');
                                            }}
                                        >
                                            <i className="fa fa-check" style={{ color: 'green' }} />
                                            <div className="document-container">
                                                <div className={item?.attachmentData.condition?.toLowerCase().includes('required') ? "category-title category-title-required" : "category-title"}>{item.displayName}</div>
                                                <div className="d-flex">
                                                    <p className="upload-suggetion">Added {getFormattedDate(item.attachmentData.latestAttachment.createdDate)}</p>
                                                    {item?.allowUpload &&
                                                        <React.Fragment>
                                                            <p className="replace-text">Add Another Document</p>
                                                            <input
                                                                data-testid={item.attachmentData.latestAttachment.identifier}
                                                                type="file"
                                                                name={item.attachmentData.identifier}
                                                                className="file-upload move-left-25"
                                                                title=""
                                                                onChange={(e) => { onChangeFileUpload(e, item.attachmentData.direction, item.attachmentData.identifier, item.attachmentData.notes, item.documentName) }}
                                                                onDragEnter={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    document.getElementById(item.attachmentData.identifier).classList.add('drop-zone-container-highlight');
                                                                }}
                                                                onDragOver={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                }}
                                                                onDragLeave={(e) => {
                                                                    e.preventDefault(); e.stopPropagation();
                                                                    document.getElementById(item.attachmentData.identifier).classList.remove('drop-zone-container-highlight');
                                                                }}
                                                                onDrop={(e) => { fileUpload(e, item.attachmentData.direction, item.attachmentData.identifier, item.attachmentData.notes, item.documentName) }} />
                                                        </React.Fragment>}
                                                </div>
                                            </div>
                                            {item?.allowDownloads && <div style={{ right: 0 }}>
                                                <i data-testid="download-docs" className="fa fa-download cursor-pointer" onClick={() => { getAttachmentData(item.attachmentData.latestAttachment.identifier, item.attachmentData.direction, item.attachmentData.latestAttachment.fileName, item.attachmentData.latestAttachment.downloadUrl, item.attachmentData.latestAttachment.expires) }} />
                                            </div>}

                                        </div>
                                        :
                                        <div
                                            className="drop-zone-container"
                                            data-testid={`${item.attachmentData.identifier}-file-replace`}
                                            id={item.attachmentData.identifier}
                                        >
                                            <i className="fa fa-check" style={{ color: 'green' }} />
                                            <div className="document-container">
                                                <div className={item?.attachmentData.condition?.toLowerCase().includes('required') ? "category-title category-title-required" : "category-title"}>{item.displayName}</div>
                                                <div className="d-flex">
                                                    <p className="upload-suggetion">Added {getFormattedDate(item.attachmentData.latestAttachment.createdDate)}</p>
                                                </div>
                                            </div>
                                            {item?.allowDownloads && <div style={{ right: 0 }}>
                                                <i data-testid="download-docs" className="fa fa-download cursor-pointer" onClick={() => { getAttachmentData(item.attachmentData.latestAttachment.identifier, item.attachmentData.direction, item.attachmentData.latestAttachment.fileName, item.attachmentData.latestAttachment.downloadUrl, item.attachmentData.latestAttachment.expires) }} />
                                            </div>}

                                        </div>
                                    }
                                </div>
                            )
                        } else {
                            return (
                                <div className="mt-20" key={i}>
                                    <label htmlFor="file">
                                        <div
                                            className="drop-zone-container"
                                            data-testid={`${item.attachmentData.identifier}-file-upload`}
                                            id={item.attachmentData.identifier}
                                            onFocus={() => {
                                                document.getElementById(item.attachmentData.identifier).classList.add('drop-zone-container-highlight');
                                            }}
                                            onBlur={() => {
                                                document.getElementById(item.attachmentData.identifier).classList.remove('drop-zone-container-highlight');
                                            }}
                                        >
                                            {item.allowUpload && (
                                                <i className="fa fa-plus" />
                                            )}
                                            <div className="document-container">
                                                <h1 className={item?.attachmentData?.condition?.toLowerCase().includes('required') ? "category-title category-title-required" : "category-title"}>{item.displayName}</h1>
                                                {item.allowUpload ? (
                                                    <p className="upload-suggetion"><span className="click-text">Click here;</span> or drag a document to upload.</p>
                                                ) : (
                                                    <p className="upload-suggetion">This document will be added by the adjuster</p>
                                                )}

                                                {item.allowUpload &&
                                                    <input
                                                        type="file"
                                                        name={item.attachmentData.identifier}
                                                        data-testid={item.attachmentData.identifier}
                                                        className="file-upload"
                                                        title=""
                                                        onChange={(e) => { onChangeFileUpload(e, item.attachmentData.direction, item.attachmentData.identifier, item.attachmentData.notes, item.documentName) }}
                                                        onDragEnter={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            document.getElementById(item.attachmentData.identifier).classList.add('drop-zone-container-highlight');
                                                        }}
                                                        onDragOver={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                        }}
                                                        onDragLeave={(e) => {
                                                            e.preventDefault(); e.stopPropagation();
                                                            document.getElementById(item.attachmentData.identifier).classList.remove('drop-zone-container-highlight');
                                                        }}
                                                        onDrop={(e) => { fileUpload(e, item.attachmentData.direction, item.attachmentData.identifier, item.attachmentData.notes, item.documentName) }} />
                                                }
                                            </div>
                                        </div>
                                    </label>
                                </div>
                            )
                        }
                    })}
                    {fileTypeError &&
                        <div className="mt-20">
                            <ErrorMessage error={fileTypeError} />
                        </div>
                    }
                    {fileSizeError &&
                        <div className="mt-20">
                            <ErrorMessage error={fileSizeError} />
                        </div>
                    }
                    {expireMessage &&
                        <div className="mt-20">
                            <ErrorMessage error={expireMessage} />
                        </div>
                    }
                    <div className="document-helper-text mt-20" style={{fontStyle: "italic"}}>
                        If you are done attaching documents, you can click <a title="Exit Claim" className="card-sub-title" onClick={() => { routeToLandingPage() }}>Exit Claim</a>
                        <br/>You can access your claim by referencing your claim number to attach any additional documents.
                    </div>
                </Card>
            </div>
        </React.Fragment>
    )
};

export default ClaimDocument;